<template>
  <hic-dialog :close-on-click-modal="false" :visible="visible" append-to-body title="按金管理" @open="open"
    @close="cancel" width="60rem" top="10vh">
    <el-main style="padding: 0 10px; height: 31rem">
      <div v-if="hospitalization" v-loading="meta.loading" style="padding: 0.5rem 0.5rem">
        <el-descriptions :column="4">
          <template slot="title">{{ hospitalization.patientName }}</template>
          <el-descriptions-item label="住院号">{{ hospitalization.ipNo }}</el-descriptions-item>
          <el-descriptions-item label="医保类型">{{ hospitalization.ipType }}</el-descriptions-item>
          <el-descriptions-item label="按金总额" contentStyle="color:red">
            <div slot="label">
              <el-tooltip class="item" effect="dark" content="入院至今" placement="top">
                <span>按金总额</span>
              </el-tooltip>
            </div>
            {{ hisTotal | fmtFloat(2) }}
          </el-descriptions-item>
          <el-descriptions-item label="本期总额" contentStyle="color:red">
            <div slot="label">
              <el-tooltip class="item" effect="dark" content="上次结算至今" placement="top">
                <span>本期总额</span>
              </el-tooltip>
            </div>
            {{ total | fmtFloat(2) }}
          </el-descriptions-item>
        </el-descriptions>
        <el-collapse v-model="meta.names" accordion>
          <el-collapse-item name="1">
            <template slot="title">
              <el-row type="flex" justify="space-between" align="middle" style="width:95%">
                <h3 class="left">预交金：<span class="money">{{ depositTotal | fmtFloat(2) }}</span></h3>
                <div v-if="meta.names.indexOf('1')>=0">
                  <el-button type="primary" @click.stop="depositNew" size="mini" v-if="deposit.showState=='list'"
                    icon="el-icon-plus">
                    缴 费</el-button>
                  <el-button type="danger" @click.stop="deposit.showState = 'list'" size="mini"
                    v-if="deposit.showState!='list'" icon="el-icon-close">
                    取 消</el-button>
                </div>
              </el-row>
            </template>
            <el-card shadow="never" v-if="deposit.showState=='info'">
              <div slot="header" class="center">
                <b>缴费详细</b>
              </div>
              <el-descriptions :colon="false" :column="4">
                <el-descriptions-item label="记录类型:"
                  :content-class-name="deposit.entity.type==Enum.DepositType.退费 ? 'danger' : 'success'">{{
                  deposit.entity.type }}</el-descriptions-item>
                <el-descriptions-item label="缴费金额:" contentStyle="color:red">{{ deposit.entity.amount }}
                </el-descriptions-item>
                <el-descriptions-item label="缴费方式:">{{ deposit.entity.payWay | dictText("PayWay") }}
                </el-descriptions-item>
                <el-descriptions-item label="缴费时点:">{{ deposit.entity.occasion }}</el-descriptions-item>

                <el-descriptions-item v-if="deposit.entity.payWay == 'ZP'" label="支票号:">{{ deposit.entity.payWay |
                dictText("PayWay") }}</el-descriptions-item>
                <el-descriptions-item v-if="deposit.entity.payWay == 'ZP'" label="开户行:">{{ deposit.entity.payWay |
                dictText("PayWay") }}</el-descriptions-item>
                <el-descriptions-item label="交款人:">{{ deposit.entity.payerName }}</el-descriptions-item>
                <el-descriptions-item label="联系方式:">{{ deposit.entity.payerPhone }}</el-descriptions-item>
                <el-descriptions-item label="收费员:">{{ deposit.entity.operator }}</el-descriptions-item>
                <el-descriptions-item label="收费时间:">{{ deposit.entity.operateTime | fmtDate }}</el-descriptions-item>
              </el-descriptions>
              <div class="right">
                <span v-if="!!deposit.entity.offsetId" class="warning">当前缴费记录已经退费!</span>
                <span v-if="deposit.entity.settlementStatus==Enum.SettlementStatus.已结算"
                  class="warning">当前缴费记录已经结算!</span>
                <el-button
                  v-if="!deposit.entity.offsetId && deposit.entity.settlementStatus == Enum.SettlementStatus.未结算"
                  @click.native="deposit.showState = 'refund'" type="danger" size="small" class="left-pad" plain>
                  退 费
                </el-button>
                <el-button @click.native="deposit.showState = 'list'" type="info" size="small" class="left-pad" plain>
                  取 消
                </el-button>
              </div>
            </el-card>
            <el-card shadow="never" v-else-if="deposit.showState=='pay'">
              <div slot="header" class="center">
                <b>缴费确认</b>
              </div>
              <el-form class="left" ref="info" :rules="rules" :inline="true" :model="deposit.entity" label-width="6rem">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="缴费金额：" prop="amount">
                      <el-input type="text" maxlength="6" v-model="deposit.entity.amount" placeholder="请输入预交金额"
                        class="edit-wide" size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="缴费方式：" prop="payWay">
                      <hic-dict-selector v-model="deposit.entity.payWay" dict-type="PayWay" auto class="edit-wide"
                        placeholder="请选择收款方式"></hic-dict-selector>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="deposit.entity.payWay == 'ZP'">
                    <el-form-item label="支票号：" prop="zpNo">
                      <el-input v-model="deposit.entity.zpNo" type="number" placeholder="请输入支票号" class="edit-wide"
                        size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="deposit.entity.payWay == 'ZP'">
                    <el-form-item label="开户行：" prop="zpBank">
                      <el-input v-model="deposit.entity.zpBank" type="number" placeholder="请输入开户行" class="edit-wide"
                        size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="交款人：" prop="payerName">
                      <el-input v-model="deposit.entity.payerName" maxlength="10" placeholder="请输入交款人" class="edit-wide"
                        size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系方式：" prop="payerPhone">
                      <el-input v-model="deposit.entity.payerPhone" placeholder="请输入交款人联系方式" class="edit-wide"
                        size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" class="right">
                    <el-checkbox v-model="deposit.ifPrint">打印凭据</el-checkbox>
                    <el-button :loading="meta.loading" @click="depositPay" type="success" size="small" class="left-pad"
                      plain>收 款</el-button>
                    <el-button @click.native="deposit.showState='list'" type="info" size="small" class="left-pad" plain>
                      取 消
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
            <el-card shadow="never" v-else-if="deposit.showState=='refund'">
              <div slot="header" class="center">
                <b>退费确认</b>
              </div>
              <el-form class="left" ref="info" :rules="rules" :inline="true" :model="deposit.entity" label-width="6rem">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="退费金额：" prop="amount">
                      <span class="money">{{ deposit.entity.amount }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="退费方式：" prop="payWay">
                      <hic-dict-selector v-model="deposit.entity.payWay" dict-type="PayWay" auto class="edit-wide"
                        placeholder="请选择退款方式"></hic-dict-selector>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="deposit.entity.payWay == 'ZP'">
                    <el-form-item label="支票号：" prop="zpNo">
                      {{deposit.entity.zpNo}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="deposit.entity.payWay == 'ZP'">
                    <el-form-item label="开户行：" prop="zpBank">
                      {{deposit.entity.zpBank}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="收款人：" prop="payerName">
                      <el-input v-model="deposit.entity.payerName" maxlength="10" placeholder="请输收款人" class="edit-wide"
                        size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系方式：" prop="payerPhone">
                      <el-input v-model="deposit.entity.payerPhone" placeholder="请输入收款人联系方式" class="edit-wide"
                        size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" class="right">
                    请注意，确认是否已回收缴费收据！
                    <el-button :loading="meta.loading" @click="depositDel" type="danger" size="small" class="left-pad"
                      plain>退 款</el-button>
                    <el-button @click.native="deposit.showState = 'list'" type="info" size="small" class="left-pad"
                      plain>取 消
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
            <el-skeleton v-if="deposit.showState=='list' && deposit.loading" :rows="6" animated />
            <el-table v-if="deposit.showState=='list' && !deposit.loading" :data="deposit.items">
              <el-table-column align="center" label="详细" width="80">
                <template slot-scope="{row}">
                  <el-button type="primary" @click="depositView(row)" circle icon="el-icon-search" size="mini" plain
                    title="查看详细">
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column align="right" label="金额" prop="amount" key="amount" width="100">
                <template slot-scope="{row}">
                  <el-tag v-if="!!row.offsetId" type="info" size="small">{{row.amount | fmtFloat(2)}}</el-tag>
                  <el-tag v-else type="danger " size="small"> {{row.amount |
                  fmtFloat(2)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="类型" prop="type" key="type" :filters="dictEnum.DepositType"
                :filter-multiple="false" column-key="type" :filter-method="filterHandler" align="center">
                <template slot-scope="{row}">
                  <el-tag v-if="!!row.offsetId" type="info" size="small" hit>{{row.type}}</el-tag>
                  <el-tag v-else-if="row.type==Enum.DepositType.收费" type="success" size="small" hit> {{ row.type }}
                  </el-tag>
                  <el-tag v-else-if="row.type==Enum.DepositType.退费" type="danger" size="small" hit> {{ row.type }}
                  </el-tag>
                </template>
              </el-table-column>
              <!-- <el-table-column label="时点" prop="occasion" key="occasion" :filters="dictEnum.DepositOccasion"
                  :filter-multiple="false" column-key="occasion" align="center">
                  <template slot-scope="{row}">
                    <el-tag type="primary" size="small" hit> {{ row.occasion }}
                    </el-tag>
                  </template>
                </el-table-column> -->
              <el-table-column label="方式" prop="payWay" key="payWay" :filters="dict.PayWay" :filter-multiple="false"
                column-key="payWay" :filter-method="filterHandler" align="center" width="120">
                <template slot-scope="{ row }">
                  <div>{{ row.payWay | dictText("PayWay") }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="交款人" prop="payerName" key="payerName"> </el-table-column>
              <el-table-column align="center" label="缴费日期" prop="paymentDate" key="paymentDate">
                <template slot-scope="{row}">
                  {{row.paymentDate | fmtDate}}
                </template>
              </el-table-column>
              <el-table-column align="center" label="流水号" prop="no" key="no" width="140"> </el-table-column>
              <el-table-column align="center" label="已结算" prop="settlementStatus" key="settlementStatus" width="80">
                <template slot-scope="{row}">
                  <i v-if="row.settlementStatus == Enum.SettlementStatus.已结算" class="el-icon-circle-check" />
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <el-row type="flex" justify="space-between" align="middle" style="width:95%">
                <h3 class="left">打白条：<span class="money">{{ iousTotal | fmtFloat(2) }}</span></h3>

                <div v-if="meta.names.indexOf('2')>=0">
                  <el-button type="primary" @click.stop="iousNew" size="mini" v-if="ious.showState=='list'"
                    icon="el-icon-plus">
                    申 请</el-button>
                  <el-button type="danger" @click.stop="ious.showState='list'" size="mini" v-if="ious.showState!='list'"
                    icon="el-icon-close">
                    取 消</el-button>
                </div>
              </el-row>
            </template>
            <el-card shadow="never" v-if="ious.showState=='info'">
              <div slot="header" class="center">
                <b>白条详细</b>
              </div>
              <el-descriptions :colon="false" :column="4">
                <el-descriptions-item label="状态:"
                  :content-class-name="ious.entity.state!=Enum.IousAuditState.通过 ? 'danger' : 'success'">{{
                  ious.entity.state }}</el-descriptions-item>
                <el-descriptions-item label="白条金额:" contentStyle="color:red">{{ ious.entity.amount }}
                </el-descriptions-item>
                <el-descriptions-item label="白条期限:">{{ ious.entity.endDate | fmtDate }}
                </el-descriptions-item>
                <el-descriptions-item label="申请人:">{{ ious.entity.proposer }}</el-descriptions-item>
                <el-descriptions-item label="申请原因:" :span="4">{{ ious.entity.proposeReason }}</el-descriptions-item>
                <el-descriptions-item v-if="ious.entity.state != Enum.IousAuditState.审批中" label="审批人:">{{
                ious.entity.auditorName }}</el-descriptions-item>
                <el-descriptions-item v-if="ious.entity.state != Enum.IousAuditState.审批中" label="审批时间:">{{
                ious.entity.auditTime | fmtDate }}</el-descriptions-item>
                <el-descriptions-item v-if="ious.entity.state != Enum.IousAuditState.审批中" label="审批原因:" :span="4">{{
                ious.entity.auditReason }}</el-descriptions-item>
              </el-descriptions>
              <div class="right">
                <span v-if="ious.entity.disabled" class="warning">当前白条已经被废弃!</span>
                <span v-if="$utils.Dt.isEarlier(ious.entity.endDate, $utils.Dt.today())"
                  class="warning">当前白条已经超期失效!</span>
                <el-popover
                  v-if="!ious.entity.disabled && $utils.Dt.isEarlierOrEqual($utils.Dt.today(), ious.entity.endDate) && ious.entity.state!=Enum.IousAuditState.驳回"
                  v-model="ious.delConfimVisible" placement="left" title="废弃" trigger="click" class="left-pad">
                  <p>确定要将当前白条进行废弃吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="ious.delConfimVisible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="iousUpdate('废弃')">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="small" class="left-pad" plain>废 弃</el-button>
                </el-popover>
                <el-popover
                  v-if="!ious.entity.disabled && $utils.Dt.isEarlierOrEqual($utils.Dt.today(), ious.entity.endDate) && ious.entity.state==Enum.IousAuditState.审批中"
                  v-model="ious.auditConfimVisible" placement="left" title="审批" width="250" trigger="click"
                  class="left-pad">
                  <div>
                    <el-input type="textarea" :rows="3" v-model="ious.entity.auditReason" placeholder="审批原因"></el-input>
                  </div>
                  <br />
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="ious.auditConfimVisible = false">取消</el-button>
                    <el-button size="mini" type="success" @click="iousUpdate('通过')">通过</el-button>
                    <el-button size="mini" type="danger" @click="iousUpdate('驳回')">驳回</el-button>
                  </div>
                  <el-button slot="reference" type="warning" size="small" class="left-pad" plain>审 批</el-button>
                </el-popover>
                <el-button @click.native="ious.showState = 'list'" type="info" size="small" class="left-pad" plain>取 消
                </el-button>
              </div>
            </el-card>
            <el-card shadow="never" v-if="ious.showState=='app'">
              <div slot="header" class="center">
                <b>白条申请确认</b>
              </div>
              <el-form class="left" ref="info" :rules="rules" :inline="true" :model="ious.entity" label-width="6rem">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="申请金额：" prop="amount">
                      <el-input type="text" maxlength="20" v-model="ious.entity.amount" placeholder="请输入申请金额"
                        class="edit-wide" size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效期：" prop="endDate">
                      <el-date-picker size="small" v-model="ious.entity.endDate" type="date" placeholder="请选择有效期"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        :picker-options="$utils.Dt.picker(['一周后', '二周后', '一个月后', '半年后', '一年后'], '>=')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="申请原因：" prop="proposeReason">
                      <el-input type="textarea" v-model="ious.entity.proposeReason" placeholder="请输入申请原因"
                        style="width:43rem" size="small" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" class="right">
                    <el-button :loading="meta.loading" @click="iousApp" type="success" size="small" class="left-pad"
                      plain>确 定</el-button>
                    <el-button @click.native="ious.showState='list'" type="info" size="small" class="left-pad" plain>
                      取 消
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
            <el-table v-if="ious.showState=='list'" :data="ious.items">
              <el-table-column align="center" label="查看" width="80">
                <template slot-scope="{row}">
                  <el-button type="primary" @click="iousView(row)" circle icon="el-icon-search" size="mini" plain>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column align="right" label="金额" prop="amount" key="amount" width="100">
                <template slot-scope="{row}">
                  <el-tag v-if="iousIsDisabled(row)" type="info" size="small">{{row.amount | fmtFloat(2)}}</el-tag>
                  <el-tag v-else type="danger " size="small"> {{row.amount | fmtFloat(2)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" width="120" label="有效期" prop="endDate" key="endDate">
                <template slot-scope="{ row }">
                  <el-tag v-if="$utils.Dt.isEarlier(row.endDate, $utils.Dt.today())" type="danger" effect="plain"
                    size="small">{{ row.endDate | fmtDate }}</el-tag>
                  <span v-else>{{ row.endDate | fmtDate }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="申请人" prop="proposer" key="proposer"> </el-table-column>
              <el-table-column align="center" label="申请时间" prop="proposeTime" key="proposeTime">
                <template slot-scope="{row}">
                  {{row.proposeTime | fmtDate}}
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop="state" key="state" column-key="state"
                :filters="dictEnum.IousAuditState" :filter-multiple="false" :filter-method="filterHandler">
                <template slot-scope="{ row }">
                  <el-tag v-if="row.disabled" type="info" effect="plain" size="small">废弃</el-tag>
                  <el-tag v-else-if="$utils.Dt.isEarlier(row.endDate, new Date())" type="info" effect="plain" size="small">已过期</el-tag>
                  <el-tag v-else-if="row.state==Enum.IousAuditState.驳回" type="danger" effect="plain" size="small">{{
                  row.state }}</el-tag>
                  <el-tag v-else-if="row.state==Enum.IousAuditState.通过" type="success" effect="plain" size="small">{{
                  row.state }}</el-tag>
                  <el-tag v-else-if="row.state==Enum.IousAuditState.审批中" type="warning" effect="plain" size="small">{{
                  row.state }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="审批人" prop="auditorName" key="auditorName"> </el-table-column>
              <el-table-column align="center" label="审批时间" prop="auditTime" key="auditTime">
                <template slot-scope="{row}">
                  {{row.auditTime | fmtDate}}
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-main>
  </hic-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  props: {
    title: String,
    infoDetail: Object,
    visible: Boolean,
    isNew: Boolean,
    hospitalization: Object,
  },
  data() {
    var checkFloat = (rule, value, callback) => {
      let frex = /^[0-9]+\.?[0-9]*$/;
      if (!value) return callback();
      if (!frex.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };

    var ValidatePhone = (rule, val, callback) => {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/; //手机号码
      var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/; // 座机格式  区号之后用'-'隔开
      if (isMob.test(val) || isPhone.test(val)) {
        callback();
      } else {
        callback(new Error("请输入正确的联系方式"));
      }
    };

    return {
      meta: {
        loading: false,
        showPayment: false,
        names: ["1"]
      },
      deposit: {
        items: [],
        entity: {},
        loading: false,
        saving: false,
        ifPrint: false,
        showState: "list"
      },
      ious: {
        items: [],
        entity: {},
        saving: false,
        showState: "list",
        delConfimVisible: false,
        auditConfimVisible: false,
      },
      rules: {
        amount: [
          { required: true, message: "请输入预交金额", trigger: "blur" },
          { validator: checkFloat, trigger: "blur" },
        ],
        payWay: [{ required: true, message: "请选择支付方式", trigger: "change" }],
        zpNo: [{ required: true, message: "请输入支票号", trigger: "blur" }],
        zpBank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        payerName: [{ required: true, message: "请输入交款人", trigger: "blur" }],
        payerPhone: [
          { required: true, message: "请输入交款人联系方式", trigger: "blur" },
          { validator: ValidatePhone, trigger: "blur" },
        ],
        qzAmount: [
          { required: true, message: "请输入可欠账额度", trigger: "blur" },
          { validator: checkFloat, trigger: "blur" },
        ],
        qzEndDate: [{ required: true, message: "请选择欠账截止日期", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    hisTotal() {
      return this.deposit.items.reduce((sum, item) => sum + item.amount, 0)
    },
    total() {
      return this.depositTotal + this.iousTotal
    },
    depositTotal() {
      return this.deposit.items.reduce((sum, item) => {
        let amount = item.amount
        if (item.settlementStatus == this.Enum.SettlementStatus.已结算) {
          amount = 0
        }
        return sum + amount
      }, 0)
    },
    iousTotal() {
      return this.ious.items.reduce((sum, item) => {
        let amount = item.amount
        if (this.iousIsDisabled(item)) {
          amount = 0
        }
        return sum + amount
      }, 0)
    },
  },
  mounted() {
    this.open()
  },
  methods: {
    open() {
      this.$utils.log("opened")
      this.meta = {
        loading: false,
        showPayment: false,
        names: ["1"]
      }
      this.deposit = {
        items: [],
        entity: {},
        loading: false,
        saving: false,
        ifPrint: false,
        showState: "list"
      }
      if (!this.hospitalization) {
        return
      }
      this.depositRefresh()
      this.ious = {
        items: [],
        entity: {},
        saving: false,
        showState: "list",
        delConfimVisible: false,
        auditConfimVisible: false,
      }
      api.Ious.query({ ipNo: this.hospitalization.ipNo }).then(res => {
        this.ious.items = res.items
      })
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    depositRefresh() {
      this.deposit.loading = true
      api.Deposit.query({
        ipNo: this.hospitalization.ipNo,
        sort: "id",
        asc: false
      }).then(res => {
        this.deposit.items = res.items
      }).finally(() => {
        this.deposit.loading = false
      })
    },
    depositNew() {
      this.deposit.entity = {
        ipNo: this.hospitalization.ipNo,
        patientCode: this.hospitalization.patientCode,
        patientName: this.hospitalization.patientName,
        type: this.Enum.DepositType.收费
      }
      this.deposit.showState = 'pay'
    },
    depositPay() {
      this.deposit.saving = true
      // 需要调用费用微服务缴费
      let payment = { id: 1, date: this.$utils.Dt.now() }

      this.deposit.entity.ipNo = this.hospitalization.ipNo
      this.deposit.entity.patientCode = this.hospitalization.patientCode
      this.deposit.entity.patientName = this.hospitalization.patientName
      this.deposit.entity.paymentType = this.Enum.DepositType.收费
      if (this.hospitalization.state == this.Enum.HospitalizationState.登记) {
        this.deposit.entity.occasion = this.Enum.DepositOccasion.入院缴费
      } else if (this.hospitalization.state == this.Enum.HospitalizationState.已离院) {
        this.deposit.entity.occasion = this.Enum.DepositOccasion.入院缴费
      } else {

        this.deposit.entity.occasion = this.Enum.DepositOccasion.在院补缴
      }
      this.deposit.entity.paymentId = payment.id
      this.deposit.entity.paymentDate = payment.date
      this.deposit.entity.printTimes = 0
      this.deposit.entity.settlementStatus = this.Enum.SettlementStatus.未结算
      api.Deposit.save(this.deposit.entity)
        .then(res => {
          this.deposit.items.unshift(res)
          this.$message.success("缴费成功！")
          this.deposit.showPay = false
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.deposit.saving = false
        })
    },
    depositView(row) {
      this.deposit.entity = this.$utils.Obj.clone(row)
      this.deposit.showState = "info"
    },
    depositDel() {
      this.deposit.saving = true
      // 需要调用费用微服务退费
      let payment = { id: 1, date: this.$utils.Dt.now() }

      this.deposit.entity.paymentId = payment.id
      this.deposit.entity.paymentDate = payment.date

      api.Deposit.refund(this.deposit.entity)
        .then(res => {
          this.depositRefresh()
          this.$message.success("退费成功！")
          this.deposit.showRefund = false
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.deposit.saving = false
        })
    },
    iousRefresh() {
      api.Ious.query({
        ipNo: this.hospitalization.ipNo,
        sort: "id",
        asc: false
      }).then(res => {
        this.ious.items = res.items
      })
    },
    iousApp() {
      this.ious.saving = true

      this.ious.entity.ipNo = this.hospitalization.ipNo
      this.ious.entity.patientCode = this.hospitalization.patientCode
      this.ious.entity.patientName = this.hospitalization.patientName
      this.ious.entity.state = this.Enum.IousAuditState.审批中

      api.Ious.save(this.ious.entity)
        .then(res => {
          this.ious.items.push(res)
          this.$message.success("申请成功！")
          this.ious.showState = "list"
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.ious.saving = false
        })
    },
    iousView(row) {
      this.ious.entity = this.$utils.Obj.clone(row)
      this.ious.showState = "info"
    },
    iousNew() {
      this.ious.entity = {
        ipNo: this.hospitalization.ipNo,
        patientCode: this.hospitalization.patientCode
      }
      this.ious.showState = 'app'
    },
    iousUpdate(action) {
      if (action == "废弃") {
        this.ious.entity.disabled = true
      } else {
        if (action == "通过") {
          this.ious.entity.state = this.Enum.IousAuditState.通过
        } else if (action == "驳回") {
          if (!this.ious.entity.auditReason) {
            this.$message.warning("审批原因不能为空！")
            return
          }
          this.ious.entity.state = this.Enum.IousAuditState.驳回
        } else {
          return
        }
        
        this.ious.entity.auditorId = this.user.id
        this.ious.entity.auditorName = this.user.name
        this.ious.entity.auditTime = this.$utils.Dt.now()
      }
      this.ious.saving = true
      api.Ious.save(this.ious.entity)
        .then(res => {
          this.$message.success(`${action}成功！`)
          this.iousRefresh()
          this.ious.auditConfimVisible = false
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.ious.saving = false
        })
    },
    iousIsDisabled(item) {
      return item.disabled || item.state != this.Enum.IousAuditState.通过 || this.$utils.Dt.isEarlier(item.endDate, this.$utils.Dt.today())
    },
    cancel() {
      this.$emit("update:visible", false);
    },
  }
};
</script>

<style scoped>
.money {
  color: red;
  font-weight: 500;
}
</style>
